<template>
<v-card-text>
  <v-switch :label="`${$t('schema.builder.inputs.options.required')}`" :input-value="options.required" @change="update({required: $event})"></v-switch>
  <v-select  :value="options.answer" hint="Wybierz" placeholder="Wybierz odpowiedz" @change="setAnswer($event)" v-if="$store.state.schemaBuilder.type == schemaType.TEST" item-text="value" item-value="key" label="Prawidłowa odpowieź" :items="values"></v-select>
  <v-text-field :value="options.answer_points" placeholder="1" @change="setAnswerPoints($event)" v-if="$store.state.schemaBuilder.type == schemaType.TEST"  :label="$t('test.answer_points')" ></v-text-field>
</v-card-text>
</template>
<script>
import options from "@/mixins/options"
import Langs from '@/plugins/langs'
import schemaType from "@/enums/schemaType";

export default {
  name: "radio-options",
  computed: {
    values() {
      return this.$store.state.schemaBuilder.fields.find(el => el.id == this.id).values
    }
  },
  data() {
    return {
      lang: process.env.VUE_APP_LOCALE,
      answer : false,
      schemaType
    }
  },
  mixins: [options],
  methods: {
    //val can be value name when it is new input/value option or value key when we edditing schema and value option existed
    setAnswer(val){
      let key = this.values.findIndex(el => el.value == val)
      key = key == - 1 ? val : key + 1
      this.update({
        answer : key
      })
    },
    setAnswerPoints(val){
      this.update({
        answer_points : val
      })
    },
    getValue(orgValue) {
      return orgValue
    },

  },
  created() {
    if(this.$store.state.schemaBuilder.type == schemaType.TEST) {
      this.setAnswerPoints(1)
    }
  }

}
</script>
<style>
</style>
